import React from 'react';

import { ReactComponent as IconAirplaneBeachPalm } from 'media/svg/airplaneBeachPalm.svg';

import styles from './Recommender.module.scss';

const Recommender = () => (
    <div className={styles.RecommenderSkeleton}>
        <header />
        <div className={styles.Wrapper}>
            {[...Array(3)].map((_, index) => (
                <div key={index} className={styles.Box}>
                    <div className={styles.Image}>
                        <IconAirplaneBeachPalm />
                    </div>
                    <div className={styles.Line} />
                    <div className={styles.Line} />
                    <div className={styles.Line} />
                    <div className={styles.Line} />
                </div>
            ))}
        </div>
    </div>
);

export default Recommender;
